import { PAID_ONLINE } from './riderWork';

const TO_PAY = { card: 'To pay by card', mobile: 'To pay with EcoCash', paynow: 'To pay with mobile money' };

/**
 * What the client's tracking says about the money, from the delivery's own
 * `payment_method` and `payment_status`. Until 11 Oct 2026 it said "To pay the
 * rider, in cash" on every delivery, the ones paid by card too: the client's
 * half of the rider's "Collect cash" found the same day.
 */
export function clientPaymentLine(d) {
  const method = String(d?.payment_method || 'cash').toLowerCase();

  if (method === 'cash') return 'To pay the rider, in cash';

  const paid = PAID_ONLINE[method] || 'Paid online';

  switch (d?.payment_status) {
    case 'paid':
      return paid;
    case 'refund_due':
      return `${paid}, a refund is on its way`;
    case 'refunded':
      return `${paid}, refunded`;
    default:
      return TO_PAY[method] || 'To pay online';
  }
}
